import type { SVGProps } from "react";
export interface VolleyballIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function VolleyballIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: VolleyballIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.94 1.578a1.125 1.125 0 1 1 2.084.844 12.7 12.7 0 0 0-.855 3.488c4.34.237 7.72 1.818 10.615 4.743a1.125 1.125 0 1 1-1.6 1.583c-2.47-2.495-5.293-3.85-9.04-4.075.084 1.03.3 1.98.62 2.788 2.81.385 5.98 2.076 8.303 4.75l.491.595.066.094a1.126 1.126 0 0 1-1.765 1.377l-.076-.088-.422-.511a12.8 12.8 0 0 0-2.172-1.975c-2.377 3.64-5.436 5.779-9.418 6.823a1.125 1.125 0 0 1-.57-2.177c3.397-.89 5.98-2.661 8.05-5.794-.934-.442-1.865-.73-2.725-.856-1.865 2.402-5.234 4.416-9.024 4.944a1.126 1.126 0 0 1-.31-2.23 12.7 12.7 0 0 0 3.45-1.003c-1.965-3.878-2.286-7.595-1.2-11.565l.035-.11a1.125 1.125 0 0 1 2.134.703l-.174.695c-.713 3.122-.396 6.044 1.168 9.171.848-.587 1.562-1.248 2.102-1.93-1.148-2.815-1.204-6.738.232-10.284Z"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
    </svg>
  );
}
